import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { Drawer, Dropdown } from "flowbite";
import { NotificationService } from "src/app/notifications/notification.service";
import { User } from "src/models/models";
import { UserService } from "src/services/user.service";

@Component({
  selector: "app-admin-navbar",
  templateUrl: "./admin-navbar.component.html",
})
export class AdminNavbarComponent implements OnInit {
  @ViewChild('userBtn') userBtn!: ElementRef;
  @ViewChild('user') user!: ElementRef;
  darkMode = false;
  u!: User;
  userDropdown!: Dropdown;
  @Input() drawer: Drawer | null = null;

  constructor(
    private userService: UserService,
    private meta: Meta,
    private notificationService: NotificationService,
  ) {
    this.darkMode = localStorage.getItem("darkMode") === "true";

    if (this.darkMode) {
      document.documentElement.classList.add("dark");
      this.meta.updateTag({ content: '#1F2937' }, 'name=theme-color');
    } else {
      this.meta.updateTag({ content: '#fff' }, 'name=theme-color');
    }
  }

  ngOnInit(): void {
    this.userService.getUser().subscribe((user) => {
      this.u = user;
      
      // Initialize notification service with the user ID
      if (user && user.id) {
        this.notificationService.initializeForUser(user.id);
        
        this.userDropdown = new Dropdown(this.user.nativeElement, this.userBtn.nativeElement);
      }
    });
  }

  close() {
    this.userDropdown.hide();
  }

  toggleNav() {
    if (this.drawer) {
      this.drawer.toggle();
    }
  }

  setDarkMode() {
    this.darkMode = !this.darkMode;
    localStorage.setItem("darkMode", this.darkMode.toString());
    if (this.darkMode) {
      //add dark class to html tag
      document.documentElement.classList.add("dark");
      this.meta.updateTag({ content: '#1F2937' }, 'name=theme-color');
    } else {
      //remove dark class from html tag
      document.documentElement.classList.remove("dark");
      this.meta.updateTag({ content: '#fff' }, 'name=theme-color');
    }
  }
}
